module.exports = __webpack_public_path__ + "img/bow-chiron.a12586fd.jpg";